/* eslint-disable import/no-cycle */
// TODO remove import cycles
import Modal from '../modal/modal';
/* eslint-enable import/no-cycle */

export default new class ModalUnavailabilityEtalon {
  constructor() {
    this.modalUnavailabilityEtalon = 'modal-unavailability-etalon';
    this.$modalUnavailabilityEtalon = $(`.${this.modalUnavailabilityEtalon}`);
    this.etalonIframeId = '#etalon';
    this.$etalonIframeId = $(this.etalonIframeId);

    if (!this.$modalUnavailabilityEtalon.length || !this.$etalonIframeId.length || !this.$etalonIframeId.attr('data-logout')) return;

    this.$etalonLisnks = $('a').filter(function filter() {
      const href = this.getAttribute('href');

      if (href) {
        return href.match(/^https?:\/\/etalonline.by/);
      }
      return undefined;
    });

    this.$doc = $(document);
    this.modalUnavailabilityEtalonButton = 'modal-unavailability-etalon__button';
    this.modalUnavailabilityEtalonLink = 'modal-unavailability-etalon__link';
    this.etalonPopup = '_etalon-popup';

    this.init();
  }

  init() {
    this.eventHandlers();
  }

  eventHandlers() {
    this.$etalonLisnks.on('click', (e) => {
      e.preventDefault();
      Modal.openModal(null, $(`.${Modal.modalContent}[data-modal='modal-unavailability-etalon']`));
    });

    this.$doc.on('click', `.${this.modalUnavailabilityEtalonLink}.${this.etalonPopup}, .${this.modalUnavailabilityEtalonButton}.${this.etalonPopup}`, (e) => {
      e.preventDefault();
    });
  }

  /**
     * Close modal unavailability etalon
     * @param {Object} $element
     */
  closeModalUnavailabilityEtalon($element) {
    const $wrapper = $element.closest('.modal');
    const $closeBtn = $wrapper.find('.modal__close');

    $closeBtn.trigger('click');
  }
}();
